import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithErrorHandling } from './baseQuery';
import type {
  GlobalRoleAssignment,
  SetGlobalTeamDistributionPayload,
} from './firmsService';

export const teamDistributionApiClient = createApi({
  reducerPath: 'teamDistributionApi',
  baseQuery: baseQueryWithErrorHandling,
  tagTypes: ['TeamDistribution'] as const,
  endpoints: (builder) => ({
    getGlobalTeamDistribution: builder.query<GlobalRoleAssignment[], void>({
      query: () => 'api/team-distribution/',
      providesTags: ['TeamDistribution'],
    }),
    setGlobalTeamDistribution: builder.mutation<
      GlobalRoleAssignment[],
      SetGlobalTeamDistributionPayload
    >({
      query: (body) => ({
        url: 'api/team-distribution/',
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['TeamDistribution'],
    }),
  }),
});

export const {
  useGetGlobalTeamDistributionQuery,
  useSetGlobalTeamDistributionMutation,
} = teamDistributionApiClient;
